import { InputDay } from '@vrplatform/components';
import { useMutation } from '@vrplatform/data';
import { day } from '@vrplatform/utils';
import type { AutomationRunSettings } from '@vrplatform/ui-common';

export const AutomationStartDateInput = ({
  automation: { createdAt, id: automationId, runSettings },
  refetch,
}: {
  automation: {
    id: string;
    runSettings: AutomationRunSettings;
    createdAt: string;
  };
  refetch: () => void;
}) => {
  const startDate = runSettings.startDate || createdAt;

  const { loading, mutate } = useMutation(
    (
      q,
      args: { automationId: string; newRunSettings: AutomationRunSettings }
    ) => {
      return q.updateAutomation({
        pk_columns: { id: args.automationId },
        _set: {
          runSettings: args.newRunSettings,
        },
      })?.id;
    },
    {
      successMessage: {
        message: 'Successfully updated start date.',
      },
      invalidateQueryKeys: ['automations', 'team'],
    }
  );

  const value = startDate ? day(startDate).toDate() : null;

  return (
    <InputDay
      value={value}
      onChange={(date) => {
        const newValue = date ? day(date).format('YYYY-MM-DD') : undefined;
        const oldValue = startDate ? day(startDate).format('YYYY-MM-DD') : null;
        if (oldValue === newValue) return;
        mutate({
          args: {
            automationId,
            newRunSettings: { ...runSettings, startDate: newValue },
          },
        }).then(refetch);
      }}
      loading={loading}
    />
  );
};
